import { ShoppingCart, Receipt, Package, HandCoins, Scale, Users, BarChart3, Wifi, Banknote } from "lucide-react";
import { Logo } from "@/components/Logo";

const RINGS = [
  { size: 210, dur: 16, icons: [ShoppingCart, Receipt], tone: "#F0444B" },
  { size: 330, dur: 26, rev: true, icons: [Package, HandCoins, Scale], tone: "#F6C35B" },
  { size: 450, dur: 38, icons: [Users, BarChart3, Wifi, Banknote], tone: "#5CC8E8" },
];
const STARS = [[8, 12], [22, 80], [35, 30], [48, 90], [62, 8], [74, 60], [86, 22], [92, 78], [15, 50], [55, 45], [80, 95], [5, 88]];
const TEXT_RING = Array.from({ length: 6 }, () => ["O", "R", "B", "I", "T", "·", "مدار", "·"]).flat();

function Ring({ size, dur, rev, icons, tone }) {
  const dir = rev ? "reverse" : "normal";
  return (
    <div className="absolute left-1/2 top-1/2 rounded-full border border-white/15"
      style={{ width: size, height: size, marginLeft: -size / 2, marginTop: -size / 2, animation: `orbit-spin ${dur}s linear infinite ${dir}` }}>
      <span className="absolute -top-1 left-1/2 w-2 h-2 rounded-full" style={{ background: tone, boxShadow: `0 0 12px 3px ${tone}` }} />
      {icons.map((I, i) => {
        const a = (360 / icons.length) * i + 45;
        return (
          <div key={i} className="absolute left-1/2 top-1/2" style={{ transform: `rotate(${a}deg) translate(${size / 2}px) rotate(${-a}deg)` }}>
            <div className="-ms-[22px] -mt-[22px] w-11 h-11 rounded-full bg-white/10 backdrop-blur-md border border-white/25 grid place-items-center text-white shadow-lg"
              style={{ animation: `orbit-spin ${dur}s linear infinite ${rev ? "normal" : "reverse"}` }}>
              <I className="w-5 h-5" style={{ color: tone }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function OrbitScene({ className = "" }) {
  return (
    <div className={`relative w-[480px] h-[480px] ${className}`} data-testid="orbit-scene" aria-hidden="true">
      {STARS.map(([x, y], i) => (
        <span key={i} className="absolute w-1 h-1 rounded-full bg-white" style={{ left: `${x}%`, top: `${y}%`, animation: `orbit-twinkle ${2 + (i % 4)}s ease-in-out ${i * 0.3}s infinite` }} />
      ))}
      <div className="absolute inset-[90px] rounded-full bg-[#F0444B]/20 blur-3xl" style={{ animation: "orbit-glow 5s ease-in-out infinite" }} />
      {RINGS.map((r) => <Ring key={r.size} {...r} />)}
      <div className="absolute left-1/2 top-1/2 -ml-12 -mt-12 w-24 h-24" style={{ animation: "orbit-float 6s ease-in-out infinite" }}>
        <span className="absolute inset-0 rounded-full ring-4 ring-white/20" style={{ animation: "orbit-ping 3s ease-out infinite" }} />
        <Logo className="w-24 h-24" />
      </div>
      <div className="absolute inset-[-14px] rounded-full orbit-text-ring" aria-hidden="true" data-testid="orbit-text-ring">
        {TEXT_RING.map((ch, i) => (
          <span key={i} className="absolute left-1/2 top-1/2 text-[#F28C28] text-[13px] font-light tracking-[.2em] whitespace-nowrap" dir="auto"
            style={{ fontFamily: ch === "مدار" ? "'Noto Kufi Arabic', sans-serif" : "Inter, Roboto, sans-serif", transform: `translate(-50%, -50%) rotate(${(360 / TEXT_RING.length) * i}deg) translateY(-254px)`, opacity: ch === "·" ? 0.5 : 0.9 }}>{ch}</span>
        ))}
      </div>
    </div>
  );
}
